<template>
    <div class="news-team" >
        <div>
            <h2>团队风采</h2>
            <div class="team-swiper-container">
                <div class="swiper-wrapper" ref="newsTeamList">
                    <div class="swiper-slide" @mouseenter="highlight(index)" @mouseleave="recover(index)"   v-for="(item,index) in teamList" :key="item.id">
                        <img :src="$imgUrl + item.image" alt="">
                        <h4>{{item.title}}</h4>
                        <span>{{item.addtime}}</span>
                        <p v-html="item.content"></p>
                        <div @click="teamDetail(item.id)">查看详情<i class="iconfont icon-yousanjiaoxing"></i></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper'
export default {
    name: 'NewsCenter',
    props: {
        teamList: Array
    },
    data () {
        return {
        }
    },
    methods: {
        highlight (index) {
            this.$refs.newsTeamList.getElementsByClassName('swiper-slide')[index].getElementsByTagName('div')[0].className = "highlight"
        },
        recover (index) {
            this.$refs.newsTeamList.getElementsByClassName('swiper-slide')[index].getElementsByTagName('div')[0].className = ''
        },
        imgSwiper () {
            var swiper = new Swiper('.team-swiper-container', {
                // autoplay: {
                //     disableOnInteraction: false,
                //     delay: 1500,
                //     stopOnLastSlide: true
                // },
                slidesPerView: 3,
                spaceBetween: 28,
            });
        },
        teamDetail (id) {
            this.$router.push('/newsdetail/'+id+'t')
        }
    },
    computed: {
    },
    mounted () {
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    @import '~styles/mixins.styl'
    .team-swiper-container >>> .swiper-slide
                                    p
                                        *
                                            text-indent: 0px !important
                                            font-size: 14px !important
                                            line-height: 24px !important
                                            color: #666 !important
    .news-team
        width: 100%
        max-width: 1920px
        min-width: 1440px
        margin: 0 auto
        background: #fff
        padding: 110px 0 190px
        >div
            width: 66%
            margin: 0 auto
            h2
                font-size: 42px
                text-align: center
                margin: 0 0 8%
                font-weight: 600
                letter-spacing: 2px
                color: #333
            .team-swiper-container
                overflow: hidden
                width: 100%
                .swiper-slide
                    background: #fff
                    padding-bottom: 2px
                    img
                        width: 100%
                        vertical-align: middle
                    h4
                        margin: 34px 0 20px
                        font-size: 20px
                        font-weight: 600
                        line-height: 1.4em
                        height: 2.8em
                        overflow: hidden
                        color: #000
                    span
                        color: #999
                    p
                        margin-top: 30px
                        text-ellipsis()
                        line-height: 24px
                        height: 72px
                        -webkit-line-clamp: 3
                    >div
                        cursor: pointer
                        margin-top: 1em 
                        float: left
                        border-radius: 20px
                        line-height: 34px
                        border: 1px solid #333
                        color: #333
                        padding: 0 1.2em
                        i
                            margin-left: 4px
                            font-size: 12px
                            line-height: 1em
                            vertical-align: inherit
                    .highlight
                        background: $yellow
                        color: #fff
                        border: 1px solid $yellow
</style>



// WEBPACK FOOTER //
// src/components/pc/NewsTeam.vue